<template>
  <div class="gs-app gm-sequence-assignment gm-sequence-list-assignment">
    <div class="step1 mb-6">
      <div class="activeicon">
        <p class="font-semibold text-base text-dark mb-2">
          {{ $t('frontend_groovemail_sequences_listnode_lists') }}
        </p>
      </div>
      <div class="flex border-grey-300 mt-2">
        <div class="w-full flex flex-no-wrap flex-col">
          <div class="w-full relative">
            <DownIcon class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"/>
            <select
              @change="onChangelist($event)"
              v-model="localModel.list"
              class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none"
              :disabled="this.listdisabled"
              v-bind:class="{ disabled: this.listdisabled }"
            >
              <option value disabled>
                {{ $t('frontend_groovemail_sequences_listnode_select_list') }}
              </option>
              <option
                v-for="(list, index) in lists"
                :data-name="list.name"
                :key="index"
                :value="list.id"
              >
                {{ list.name }}
              </option>
            </select>
          </div>

          <div
            class="text-primary text-sm flex items-center font-semibold cursor-pointer mt-2"
            @click="createNewList"
          >
            <PlusIcon class="h-5 w-5"/>
            <p>{{ $t('frontend_groovemail_contacts_step4_create_new_list') }}</p>
          </div>

          <div class="w-full">
            <div class="text-center w-full flex flex-row flex-wrap">
              <p
                class="list-chip font-hairline leading-8 border-0 text-primary-invert bg-primary mt-2 mr-2 relative"
                v-for="(option, index) in localModel.listassigned"
                :key="index"
              >
                <span class="text-xs font-semibold pl-2 pr-2">
                  {{ option.name }}
                </span>
                <span @click="deletelist(option)" class="px-2">
                  <span style="cursor: pointer" class="fa text-xs cross-chip"
                    >&#xf00d;</span
                  >
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import 'vue2-timepicker/dist/VueTimepicker.css';

// import icons
import PlusIcon from '@/assets/images/icons/new/plus-small_new.svg';
import DownIcon from '@/assets/images/icons/new/down_new.svg';

export default {
  name: 'ListNode',
  props: {
    model: {
      required: true,
    },
  },
  data() {
    return {
      localModel: this.model,
      currentstep: 1,
      lists: [],
      nextbtndisabled: true,
      addbtndisabled: true,
      savebtndisabled: true,
      listdisabled: false,
      listname: '',
    };
  },

  components: {
    PlusIcon,
    DownIcon,
  },

  methods: {
    createNewList() {
      this.$emit('createNewList', 6);
    },

    async updateListData(lists) {
      const mailLists = await axios.get(`/maillistonly`);
      this.lists = mailLists?.data?.data;
      if (lists && lists.data) {
        this.localModel.listassigned.push({
          name: lists.data.name,
          id: lists.data.id,
        });
      }
    },

    deletelist(option) {
      const index = this.localModel.listassigned.indexOf(option);
      this.localModel.listassigned.splice(index, 1);
    },

    getrecords() {
      this.localModel.listassigned.push({
        name: this.listname,
        id: this.localModel.list,
      });

      this.addbtndisabled = true;
      this.localModel.savelistbtn = false;
    },

    onChangelist(e) {
      this.localModel.savelistbtn = true;
      this.addbtndisabled = false;
      this.listname =
        e.target.options[e.target.options.selectedIndex].dataset.name;

      if (!this.localModel.listassigned.includes(this.listname)) {
        this.getrecords();
      }
    },

    dayshandler(option) {
      if (option.value === false) {
        const index = this.localModel.listdays.indexOf(option.title);
        if (index > -1) {
          this.localModel.listdays.splice(index, 1);
        }
      } else {
        this.localModel.listdays.push(option.title);
      }
    },
  },

  async created() {
    this.$wait.start('list');
    const mailLists = await axios.get(`/maillistonly`);
    this.lists = mailLists?.data?.data;
    this.$wait.end('list');
  },

  watch: {
    localModel() {
      this.$emit('updateModel', this.localModel);
    },
  },
};
</script>

<style scoped>
.gm-sequence-assignment .step1 {
  margin-bottom: 1.5rem;
}

.gm-sequence-assignment select {
  min-height: 2.75rem;
  height: 2.75rem;
  line-height: 1.25rem;
}

.gm-sequence-assignment .text-primary.cursor-pointer {
  min-height: 2.75rem;
  align-items: center;
  color: var(--gs-primary);
}

.gm-sequence-assignment .list-chip {
  display: inline-flex;
  align-items: stretch;
  max-width: 100%;
  min-height: 2.75rem;
  margin: 0.625rem 0.5rem 0 0;
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-sm);
  background: var(--gs-surface-subtle);
  color: var(--gs-foreground);
  line-height: 1.25rem;
  text-align: left;
}

.gm-sequence-assignment .list-chip > span:first-child {
  min-width: 0;
  padding: 0.625rem 0.25rem 0.625rem 0.75rem;
  overflow-wrap: anywhere;
}

.gm-sequence-assignment .list-chip > span:nth-child(2) {
  display: inline-flex;
  flex: 0 0 2.75rem;
  align-items: center;
  justify-content: center;
  min-width: 2.75rem;
  min-height: 2.75rem;
  padding: 0;
  color: var(--gs-danger);
  cursor: pointer;
}

.gm-sequence-assignment .list-chip > span:nth-child(2):focus-visible {
  outline: 2px solid var(--gs-primary);
  outline-offset: -2px;
}

@media (max-width: 40rem) {
  .gm-sequence-assignment .list-chip {
    display: flex;
    width: 100%;
    margin-right: 0;
  }
}
</style>
